// @ts-check

import { useQuery } from '@tanstack/vue-query';

import { useAuthStore } from '@/store-v2/auth';
import { getUserKeywords } from '@/api/keywords';
import { convertToStaleTime, createQueryKey } from '@/composables/vue-query/util';
import { storeToRefs } from 'pinia';

export const USER_KEYWORDS_QUERY_KEY = createQueryKey(['user', 'keywords']);

export function useUserKeywords() {
  const { isLoggedInUser } = storeToRefs(useAuthStore());

  if (!isLoggedInUser.value) return { userKeywords: [] };

  const query = useQuery({
    queryKey: USER_KEYWORDS_QUERY_KEY,
    staleTime: convertToStaleTime({ minutes: 60 }),
    queryFn: getUserKeywords,
  });

  return { userKeywords: query.data, ...query };
}

/** @typedef { import('@tanstack/vue-query').QueryClient } QueryClient */

/**
 * Invalidate the user keywords query.
 * @param {Object} options - The options object.
 * @param {QueryClient} options.queryClient - The query client instance.
 */
export const invalidateUserKeywords = ({ queryClient }) => {
  queryClient.invalidateQueries({ queryKey: USER_KEYWORDS_QUERY_KEY });
};
